module.exports = __webpack_public_path__ + "img/myCollect.b2ad304e.png";